import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Index from "./Index";
import HistoryModern from "./HistoryModern";

// Momento en que se cargó la página. El navegador guarda el "state" de la ruta al
// recargar (por ejemplo, si el teléfono recarga la pestaña por falta de memoria):
// una repetición abierta antes de recargar no debe volver a abrirse ni enseñar el
// Historial antiguo.
const PAGE_LOADED_AT = Date.now();
let replayOpenedInThisPage = false;

const requestKeyTime = (key) => {
  const match = /(\d{12,})\D*$/.exec(String(key || ""));
  return match ? Number(match[1]) : 0;
};

// Historial de partidas: la pantalla nueva. Las repeticiones (también las que se
// abren desde el Campeonato) siguen usando la ventana de repetición de siempre.
const History = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state || {};
  const freshOpen =
    Boolean(state.openReplayMatch) && requestKeyTime(state.openReplayRequestKey) >= PAGE_LOADED_AT;
  if (freshOpen) replayOpenedInThisPage = true;
  const showReplay = freshOpen || (Boolean(state.replayActive) && replayOpenedInThisPage);
  const staleState = !showReplay && (state.openReplayMatch || state.replayActive);

  useEffect(() => {
    if (staleState) navigate(`${location.pathname}${location.search}`, { replace: true, state: null });
  }, [location.pathname, location.search, navigate, staleState]);

  if (showReplay) return <Index forcedTab="history" />;
  return <HistoryModern />;
};

export default History;
